import {Point} from '@app/modules/svg/model/Point';
import {Triangle} from '@app/modules/svg/model/Triangle';

/**
 *            ______________
 *           /|                 |
 *          / |                 | height = a * sin(angle)
 *         /  |                 | a = height / sin(angle)
 *       a/   |                 |
 *       /    |                 | x / a = cos(angle)
 *      /     | height          | x = a * cos(angle)
 *     /angle |                 |
 *    /_______|_____________    |
 *        x
 * */
export function baseOfTriangle(angle: number, height: number): number {
  const angleRadians: number = angle * Math.PI / 180;
  const sinAlpha: number = Math.sin(angleRadians);
  const cosAlpha: number = Math.cos(angleRadians);

  if (sinAlpha === 0 || cosAlpha === 0) {
    return 1;
  }

  const a: number = height / sinAlpha;
  const x: number = a * cosAlpha;

  if (a === 0 || x === 0) {
    return 1;
  }

  return x;
}

export function isPointInTriangle(point: Point, triangle: Triangle): boolean {
  const p: Point = point;
  const p1: Point = triangle.p0;
  const p2: Point = triangle.p1;
  const p3: Point = triangle.p2;

  const alpha: number =
    ((p2.y - p3.y)*(p.x - p3.x) + (p3.x - p2.x)*(p.y - p3.y)) /
    ((p2.y - p3.y)*(p1.x - p3.x) + (p3.x - p2.x)*(p1.y - p3.y));
  const beta: number =
    ((p3.y - p1.y)*(p.x - p3.x) + (p1.x - p3.x)*(p.y - p3.y)) /
    ((p2.y - p3.y)*(p1.x - p3.x) + (p3.x - p2.x)*(p1.y - p3.y));
  const gamma: number = 1.0 - alpha - beta;

  return alpha > 0 && beta > 0 && gamma > 0;
}
